var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content",staticStyle:{"position":"relative"}},[_vm._m(0),_c('Echart',{attrs:{"options":_vm.chartOption,"width":"100%","height":"750px"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-line"},[_c('div',{staticClass:"title1"},[_vm._v("运输时间分布")])])
}]

export { render, staticRenderFns }